import { redirect, type ParsedLocation } from '@tanstack/react-router';
import { parseArtifactsSearch } from './search';

/**
 * `/content` → Artifacts' Deliverables (Kazzy, 12 Oct 2026: Content became Artifacts). An old link, bookmark or open
 * tab lands there as a replace, keeping what else it carried that Artifacts reads (a search, a campaign). The route's
 * `beforeLoad`.
 */
export function redirectContent({ location }: { location: Pick<ParsedLocation, 'search'> }): never {
  throw redirect({ to: '/artifacts', search: parseArtifactsSearch({ ...(location.search as Record<string, unknown>), kind: 'deliverable' }), replace: true });
}
